import React from 'react';
import PartnerWithPilotHelper from './PartnerWithPilotHelper';

const TrainingForAirlines = () => {
    return (
        <div className="container pb-5" style={{ maxWidth: '800px', marginTop: '75px', paddingTop: '20px' }}> 
            <h1 className="mb-4">How PilotHelper Complements and Strengthens Existing Airline Peer Support Programs</h1>

            <section className="mb-4">
                <p>
                    Many airlines have established peer support programs designed to help pilots navigate personal
                    or professional challenges. These programs play an important role in supporting pilot well-being
                    and maintaining a strong safety culture within aviation. PilotHelper is not intended to replace
                    these programs. Instead, PilotHelper is designed to complement and strengthen them by
                    expanding peer support skills across the broader pilot community.
                </p>
            </section>

            <section className="mb-4">
                <p>
                    Traditional airline peer support programs typically rely on a small group of trained volunteer
                    peer supporters. These individuals provide valuable assistance and act as designated points of
                    contact when pilots seek help. While these programs are valuable, some pilots may hesitate to
                    reach out to a designated peer supporter they do not personally know.
                </p>
            </section>

            <section className="mb-4">
                <p>
                    In many cases, pilots are more likely to open up to fellow pilots they already trust, such as close
                    friends, classmates from training, or crewmembers they regularly fly with. PilotHelper
                    strengthens this natural pilot-to-pilot support network by training all pilots, not just designated
                    peer supporters, to recognize when a colleague may be struggling and respond appropriately.
                    PilotHelper can also extend this training to pilots' family members, helping them better
                    understand the unique pressures of the aviation profession and learn how to better support their
                    loved one.
                </p>
            </section>

            <section className="mb-4">
                <p>
                    By equipping the broader pilot community and pilots' family members with peer support skills,
                    PilotHelper ensures every pilot has someone to turn to in times of need so no pilot struggles in
                    silence. This training helps people recognize early warning signs and respond appropriately,
                    making conversations about stress, fatigue, and personal challenges more likely to happen before
                    issues escalate.
                </p>
            </section>

            <PartnerWithPilotHelper organizationType="company" emailType="company" />
        </div>
    );
};

export default TrainingForAirlines;
